import Layout from '@/layout/index.vue'

export const ProfileRoute = {
  path: '/profile',
  component: Layout,
  redirect: '/profile',
  children: [
    {
      path: '/',
      component: (): Promise<any> =>
        import('@/features/profile/views/index.vue'),
      name: 'Profile',
      meta: {
        title: 'ProfileTitle',
        requiresAuth: true
      }
    }
  ]
}
